/* carrito.js — agregar y VER el carrito sin salir de la página.

   Ver el carrito abre un cajón encima de donde estás. Solo el PAGO es otra pantalla, que es
   como debe ser: el checkout es de Shopify y ahí no se experimenta.

   Progressive enhancement de verdad: sin JS, el botón del carrito es un enlace normal a /cart
   y los formularios de producto envían como siempre. Nunca se rompe la venta; solo se pierde
   la comodidad. */
(function () {
  var K = window.KAWAII || {};

  // ── dinero: se respeta el formato de la tienda, no se inventa ────────────
  function formatoDinero(centavos) {
    var f = K.dinero || '${{amount}}';
    var n = (centavos || 0) / 100;
    function sep(v, miles, dec, decimales) {
      var p = v.toFixed(decimales).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
      return decimales ? p.join(dec) : p[0];
    }
    return f
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, sep(n, '.', ',', 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, sep(n, '.', ',', 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sep(n, ',', '.', 0))
      .replace(/\{\{\s*amount\s*\}\}/g, sep(n, ',', '.', 2));
  }

  // Los títulos vienen de la tienda, no de aquí: un producto llamado Peluche "nube" o un
  // nombre con < rompería el markup si se inyectara crudo.
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function contador(n) {
    [].forEach.call(document.querySelectorAll('.carrito-num'), function (e) {
      e.textContent = n;
      e.classList.remove('late'); void e.offsetWidth; e.classList.add('late');
    });
  }

  // ── avisos ───────────────────────────────────────────────────────────────
  var avisoTimer = null;
  function aviso(texto, esError) {
    var el = document.getElementById('aviso-carrito');
    if (!el) {
      el = document.createElement('div');
      el.id = 'aviso-carrito'; el.className = 'aviso-carrito';
      el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.innerHTML = '';
    el.appendChild(document.createTextNode(texto));
    if (!esError) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'aviso-ver'; b.textContent = 'Ver carrito';
      b.addEventListener('click', abrir);
      el.appendChild(b);
    }
    el.classList.toggle('error', !!esError);
    el.classList.add('visible');
    clearTimeout(avisoTimer);
    avisoTimer = setTimeout(function () { el.classList.remove('visible'); }, 4200);
  }

  // ── el cajón ─────────────────────────────────────────────────────────────
  var cajon = document.getElementById('cajon-carrito');
  var fondo = document.getElementById('cajon-fondo');
  var cuerpo = document.getElementById('cajon-cuerpo');
  var pie = document.getElementById('cajon-pie');
  var totalEl = document.getElementById('cajon-total');
  var ultimoFoco = null;

  function pintar(c) {
    if (!cuerpo) return;
    contador(c.item_count);
    if (!c.items || !c.items.length) {
      cuerpo.innerHTML = '<p class="vacio">' +
        (document.documentElement.lang === 'en' ? 'Your cart is empty' : 'Tu carrito está vacío 🧸') +
        '</p>';
      if (pie) pie.hidden = true;
      return;
    }
    cuerpo.innerHTML = c.items.map(function (it, i) {
      var img = it.image
        ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" loading="lazy">'
        : '<span class="cajon-sinimg">🎀</span>';
      var variante = (it.variant_title && it.variant_title.indexOf('Default') === -1)
        ? '<div class="cajon-var">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="cajon-item" data-linea="' + (i + 1) + '">' +
        '<a class="cajon-img" href="' + esc(it.url) + '">' + img + '</a>' +
        '<div class="cajon-datos">' +
          '<a class="cajon-titulo" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          variante +
          '<div class="precio">' + formatoDinero(it.final_line_price) + '</div>' +
        '</div>' +
        '<div class="cajon-cant">' +
          '<button type="button" data-mas="-1" aria-label="Quitar uno">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" data-mas="1" aria-label="Añadir uno">+</button>' +
          '<button type="button" class="cajon-quitar" data-quitar="1">Quitar</button>' +
        '</div>' +
      '</div>';
    }).join('');
    if (pie) pie.hidden = false;
    if (totalEl) totalEl.textContent = formatoDinero(c.total_price);
  }

  function cargar() {
    // K.demo solo existe en la vista previa local de amigo (no hay Shopify detrás). En la
    // tienda real el flag no está y este camino nunca corre.
    if (K.demo) return Promise.resolve(pintar(K.demo));
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(pintar)
      .catch(function () { /* sin red el cajón queda como estaba: no se rompe la página */ });
  }

  function abrir() {
    if (!cajon) { window.location.href = '/cart'; return; }
    ultimoFoco = document.activeElement;
    cajon.hidden = false; if (fondo) fondo.hidden = false;
    document.body.classList.add('cajon-abierto');
    requestAnimationFrame(function () { cajon.classList.add('visible'); if (fondo) fondo.classList.add('visible'); });
    cargar();
    var cerrarBtn = document.getElementById('cajon-cerrar');
    if (cerrarBtn) cerrarBtn.focus();
  }

  function cerrar() {
    if (!cajon) return;
    cajon.classList.remove('visible'); if (fondo) fondo.classList.remove('visible');
    document.body.classList.remove('cajon-abierto');
    setTimeout(function () { cajon.hidden = true; if (fondo) fondo.hidden = true; }, 300);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  // Sin este candado, dos clics rápidos mandan el MISMO número de línea y el segundo borra
  // otro producto: después de la primera respuesta las líneas se recorren.
  var ocupado = false;
  function cambiar(linea, cantidad) {
    if (ocupado) return;
    ocupado = true;
    if (cuerpo) cuerpo.classList.add('trabajando');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: linea, quantity: cantidad })
    }).then(function (r) { return r.json(); }).then(pintar)
      .catch(function () { aviso('No se pudo actualizar el carrito', true); })
      .then(function () { ocupado = false; if (cuerpo) cuerpo.classList.remove('trabajando'); });
  }

  // El botón flotante abre el cajón en vez de navegar (pero sigue siendo un enlace real).
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;          // click sobre texto suelto o el documento
    if (t.closest('a.flotante-carrito, a.carrito-enlace') && cajon) {
      ev.preventDefault(); abrir(); return;
    }
    if (t.closest('#cajon-cerrar') || t.closest('#cajon-fondo')) { cerrar(); return; }

    var item = t.closest('.cajon-item');
    if (!item) return;
    var linea = parseInt(item.getAttribute('data-linea'), 10);
    var cant = parseInt(item.querySelector('.cajon-cant span').textContent, 10) || 1;
    if (t.closest('[data-quitar]')) return void cambiar(linea, 0);
    var mas = t.closest('[data-mas]');
    if (mas) cambiar(linea, Math.max(0, cant + parseInt(mas.getAttribute('data-mas'), 10)));
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && cajon && !cajon.hidden) cerrar();
  });

  // ── agregar sin salir de la página ───────────────────────────────────────
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    ev.preventDefault();
    var boton = f.querySelector('[type=submit]');
    var antes = boton ? boton.textContent : '';
    if (boton) { boton.disabled = true; boton.textContent = '…'; }
    function restaurar() { if (boton) { boton.disabled = false; boton.textContent = antes; } }

    fetch('/cart/add.js', { method: 'POST', body: new FormData(f),
                            headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) {   // Shopify explica por qué (sin stock, variante mala): se muestra tal cual
          aviso(res.d.description || res.d.message || 'No se pudo agregar', true);
          restaurar(); return;
        }
        aviso('🛒 ' + (res.d.title || 'Agregado') + ' — listo');
        if (boton) boton.textContent = '✓';
        setTimeout(restaurar, 1200);
        return cargar();
      })
      .catch(function () { aviso('No se pudo agregar. Revisa tu conexión.', true); restaurar(); });
  });

  cargar();   // el contador arranca con la cifra real
})();
